var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mask",staticClass:"ur-progress__mask",style:(_vm.mask_style)},[_c('ur-indeterminate-progress',{attrs:{"shape":"circle","size":this.size,"speed":this.speed,"message":this.message,"message-direction":"bottom","masked":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }